/* ========================== */  
/* ========= import ========= */  
/* ========================== */ 
/* ====== React ====== */
import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { assets } from '03CommonApiParts/Configuration';

/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
const SdivCheckGroup = styled.div`
    height:24px;
`;
const SlabelCheck = styled.label`//ラジオボタンのラベル
    margin-right: 10px;
    height:18px;
    white-space: nowrap;
    cursor: pointer;
   
`;
const SinputCheck = styled.input`
    position: relative;
    top:1px;
    cursor: pointer;
`;
/* How To Use 
       <TableCheck 
            id={items.name}
            label={items.title}
            defaultChecked={dataRow[items.name]}
            register= {register(`${payload}.${items.name}`,
            {
                required: items.required?CFArrayFount(inputCheckMaster.list,'value','required').label:'',
            })}
            // readOnly={items.readOnly}
            />
*/

/*==================*/
/*=====  Main  =====*/
/*==================*/
export const TableCheckOnChange = (props) => {

    /* --------------------------- */
    /* --------- valiables -------- */
    /* --------------------------- */
    const { id,register, label ,checked, defaultChecked,disabled,onChange,value,style } = props;

    /*--------------------------*/  
    /*------ Start Render ------*/  
    /*--------------------------*/ 
    return (
        <SdivCheckGroup>
            <SlabelCheck htmlfor={id} style={style}>
                <SinputCheck
                    {...register}
                    defaultChecked={defaultChecked}
                    disabled={disabled}
                    checked={checked}
                    value={value}
                    style={{fontSize:assets().size.baseText}}
                    // readOnly={readOnly}
                    onChange={onChange}
                    type='checkbox'
                />
                {label}
            </SlabelCheck>
        </SdivCheckGroup>
    );
};
